import { neutralDividerRestDelta, neutralPalette } from '../fluent-design-system';
import { findClosestBackgroundIndex, getSwatch, isDarkMode } from './palette';
import { colorRecipeFactory } from './common';
const neutralDividerAlgorithm = (designSystem) => {
    const palette = neutralPalette(designSystem);
    const backgroundIndex = findClosestBackgroundIndex(designSystem);
    const delta = neutralDividerRestDelta(designSystem);
    const direction = isDarkMode(designSystem) ? -1 : 1;
    const index = backgroundIndex + direction * delta;
    return getSwatch(index, palette);
};
/**
 * @internal
 */
export const neutralDividerRest = colorRecipeFactory(neutralDividerAlgorithm);
